const emmList = [
  {
    key: "SFN2022000000001",
    tarih: "01/01/2022",
    faturaNo: "4660392430",
    unvan: "Özgür Teknoloji A.Ş",
    senaryo: "TEMEL",
    tür: "Satış",
    toplamTutar: "Temel",
    durum: "Eksik bilgi",
    durumAcıklaması: "İmza Bekliyor",
    envelopeNo: "SFN2022000000001",
    createDate: "01/01/2022",
    sender: "Özgür Teknoloji A.Ş",
    baseInvoiceCount: "5",
    commercialInvoiceCount: "5",
    status: "Eksik bilgi",
    kalemEkTipTutar: "SFN2022000000001",
    year: "2022",
    month: "Ocak",
  },
  {
    key: "SFN2022000000002",
    tarih: "01/01/2022",
    faturaNo: "4660392430",
    unvan: "Özgür Teknoloji A.Ş",
    senaryo: "TEMEL",
    tür: "Satış",
    toplamTutar: "Temel",
    durum: "Eksik bilgi",
    durumAcıklaması: "İmza Bekliyor",
    envelopeNo: "SFN2022000000002",
    createDate: "01/01/2022",
    sender: "Özgür Teknoloji A.Ş",
    baseInvoiceCount: "5",
    commercialInvoiceCount: "5",
    status: "Eksik bilgi",
    kalemEkTipTutar: "SFN2022000000002",
    year: "2022",
    month: "Ocak",
  }
  ,
  {
    key: "SFN2022000000003",
    tarih: "01/01/2022",
    faturaNo: "4660392430",
    unvan: "Özgür Teknoloji A.Ş",
    senaryo: "TEMEL",
    tür: "Satış",
    toplamTutar: "Temel",
    durum: "Eksik bilgi",
    durumAcıklaması: "İmza Bekliyor",
    envelopeNo: "SFN2022000000003",
    createDate: "01/01/2022",
    sender: "Özgür Teknoloji A.Ş",
    baseInvoiceCount: "5",
    commercialInvoiceCount: "5",
    status: "Eksik bilgi",
    kalemEkTipTutar: "SFN2022000000003",
    year: "2022",
    month: "Ocak",
  }
  ,
  {
    key: "SFN2022000000004",
    tarih: "01/01/2022",
    faturaNo: "4660392430",
    unvan: "Özgür Teknoloji A.Ş",
    senaryo: "TEMEL",
    tür: "Satış",
    toplamTutar: "Temel",
    durum: "Eksik bilgi",
    durumAcıklaması: "İmza Bekliyor",
    envelopeNo: "SFN2022000000004",
    createDate: "01/01/2022",
    sender: "Özgür Teknoloji A.Ş",
    baseInvoiceCount: "5",
    commercialInvoiceCount: "5",
    status: "Eksik bilgi",
    kalemEkTipTutar: "SFN2022000000004",
    year: "2022",
    month: "Ocak",
  }
];
export default emmList;
